import { MenuEntry } from '@src/menu-entry';
import finApiTransactions from '@src/fin-api/menu.ts';
import paypalTransactions from '@src/paypal/menu.ts';
import mollieTransaction from '@src/mollie/menu.ts';

export default MenuEntry.create()
    .setTitle('Kontoauszüge')
    .setChildren([
        MenuEntry.create()
            .setRoute('bank_statement_search'),
        ...finApiTransactions,
        ...paypalTransactions,
        mollieTransaction,
    ]);
